<nh-alert type="danger" [isOpen]="isError">
  <div class="row">
    <div class="col-auto icon">
      <img
        src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
        alt=""
      />
    </div>
    <div class="col message">
      <span>
        {{ errorMessage }}
      </span>
    </div>
  </div>
</nh-alert>
@if (invaidRelation) {
<div>
  <nh-alert type="danger" [isOpen]="invaidRelation">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ invalidRel | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
</div>
} @if (isRmbRmc) {
<p>{{ "RENEWAL_TEXT" | globalTranslate }}</p>
}
<nh-form
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  (validate)="onValidate($event)"
>
  <h1 class="person-label">{{ head | fullname }}</h1>
  <section [formGroup]="getControl('data')">
    <div>
      <div formArrayName="relationshipList">
        <h2 class="section-header">{{ "RELATIONSHIP" | globalTranslate }}</h2>
        <hr />
        @for (relationship of relationshipList.controls; track relationship; let
        i = $index) {
        <div>
          <ng-container class="pt-1">
            <fieldset [formGroupName]="i">
              <nh-field
                id="rene_relation"
                label="{{ 'RELATIONSHIP_STATIC_TEXT1' | translate }} {{
                  name(relationship.value.sourceIndividual)
                }}{{ 'RELATIONSHIP_STATIC_TEXT2' | globalTranslate }} {{
                  name(relationship.value.referenceIndividual)
                }}"
                class="label-section"
              >
                <select
                  nhTranslate
                  name="relation"
                  [attr.aria-label]="
                    ('RELATIONSHIP_STATIC_TEXT1' | translate) +
                    ' ' +
                    name(relationship.value.sourceIndividual) +
                    ' ' +
                    ('RELATIONSHIP_STATIC_TEXT2' | globalTranslate) +
                    ' ' +
                    name(relationship.value.referenceIndividual)
                  "
                  formControlName="relation"
                  [items]="
                    tables[gender(getControl('data.relationshipList'), i)]
                  "
                  (change)="getInverseRelationships(relationship, i, true)"
                  required
                ></select>
                @if (isUnknownRelation(i)) {
                <span class="form-text invalid-name d-block"
                  >{{ unknownGenderRelationError | globalTranslate }}
                  {{ name(relationship.value.sourceIndividual) }}
                  {{ unknownGenderRelationErrorPartB | globalTranslate }}
                  {{ name(relationship.value.referenceIndividual) }}</span
                >
                } @if (isParentRelationError(i) && !isUnknownRelation(i)) {
                <span class="form-text invalid-name d-block">{{
                  parentRelationError | globalTranslate
                }}</span>
                } @if (isYoungerParent(i) && !isParentRelationError(i) &&
                !isUnknownRelation(i)) {
                <span class="form-text invalid-name d-block">{{
                  "PARENT_GRANDPARENT_ERROR" | globalTranslate
                }}</span>
                }
              </nh-field>
              @if (relationship.value.inverse) {
              <div>
                <strong
                  ><span
                    >{{
                      name(relationship.value.referenceIndividual)
                    }}&nbsp;</span
                  >{{
                    relationship.get("inverse").value.value | globalTranslate
                  }}&nbsp;
                  <span>{{
                    name(relationship.value.sourceIndividual)
                  }}</span></strong
                >
              </div>
              }
            </fieldset>
            <br /><br />
          </ng-container>
        </div>
        }
      </div>
    </div>
    @if (isPrimaryCareEnabled) {
    <div>
      <h2 class="section-header">
        {{ "PRIMARY_CARE_GIVER" | globalTranslate }}
      </h2>
      <hr />
      <div class="row ps-0 pt-1 text-left primary-caregivers hover-red">
        <a
          title="{{ 'MORE_ABOUT_PRIMARY_CARE_GIVER' | globalTranslate }}"
          tabindex="0"
          class="btn btn-link text-start hover-red"
          href="#"
          (click)="showPrimaryCaregiverModal($event)"
        >
          <span>{{ "MORE_ABOUT_PRIMARY_CARE_GIVER" | globalTranslate }} </span>
          <span><i class="fa fa-external-link" aria-hidden="true"></i></span>
        </a>
      </div>
      <br />
      <div formArrayName="primaryCareList">
        @for (primary of primaryCareList.controls; track primary; let i =
        $index) {
        <div>
          <div [hidden]="primary['controls']['primaryCaregiver' + i].isHidden">
            <ng-container>
              <fieldset [formGroupName]="i">
                <nh-field
                  id="{{ 'rene_' + i }}"
                  label="{{
                    'PRIMARY_CARE_GIVER_STATIC_TEXT1' | globalTranslate
                  }} {{ name(primary.value.indvId) }}{{
                    'PRIMARY_CARE_GIVER_STATIC_TEXT2' | globalTranslate
                  }}"
                  class="label-section"
                >
                  <select
                    nhTranslate
                    name="primaryCaregiver"
                    [attr.aria-label]="
                      ('PRIMARY_CARE_GIVER_STATIC_TEXT1' | globalTranslate) +
                      ' ' +
                      name(primary.value.indvId) +
                      ' ' +
                      ('PRIMARY_CARE_GIVER_STATIC_TEXT2' | globalTranslate)
                    "
                    (change)="onSelected(primary.value, $event, i)"
                    formControlName="primaryCaregiver{{ i }}"
                    [items]="tables.YESNO"
                    required
                  ></select>
                </nh-field>
                @if (!primary['controls']['primaryCaregiverIndividual' +
                i].disabled) {
                <div>
                  <div class="label-section">
                    <span class="text-danger" aria-hidden="true">*</span
                    >{{ "WHO_IS" | globalTranslate }}
                    {{ name(primary.value.indvId)
                    }}{{ "PRIMARY_CARE_GIVER_STATIC_TEXT2" | globalTranslate }}
                  </div>
                  @for (indv of indivList[i]; track indv; let j = $index) {
                  <div class="pt-3 checkbox">
                    <input
                      id="primaryCaregiver_{{ i }}_{{ j }}"
                      type="checkbox"
                      (click)="
                        onIndvSelect($event, primary.value.indvId, indivList[i])
                      "
                      [value]="indv.individualId"
                      [checked]="indv.checked"
                      [attr.aria-label]="
                        indv.name +
                        ' ' +
                        ('as primary caregiver for' | globalTranslate) +
                        ' ' +
                        name(primary.value.indvId)
                      "
                      [attr.aria-required]="true"
                      tabindex="0"
                    />
                    <label
                      class="form-check-label"
                      for="primaryCaregiver_{{ i }}_{{ j }}"
                    >
                      <span class="cr" role="presentation" aria-hidden="true"
                        ><i class="cr-icon fa fa-check" aria-hidden="true"></i
                      ></span>
                      {{ indv.name }}
                    </label>
                  </div>
                  }
                </div>
                }
              </fieldset>
              <br />
            </ng-container>
          </div>
        </div>
        }
      </div>
      @if (primaryCareGiverValidations.length) {
      <div>
        <nh-alert type="danger" [isOpen]="true">
          <div class="row">
            <div class="col-auto icon">
              <img
                src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
                alt=""
              />
            </div>
            <div class="col message">
              <span>{{ "RELATIONSHIP_ALERT_TEXT" | globalTranslate }}</span>
            </div>
          </div>
        </nh-alert>
      </div>
      }
    </div>
    }
  </section>
</nh-form>